import { render, staticRenderFns } from "./genericSubClassifier.vue?vue&type=template&id=cbdb3608&scoped=true"
import script from "./genericSubClassifier.vue?vue&type=script&lang=js"
export * from "./genericSubClassifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb3608",
  null
  
)

export default component.exports